export default {"src":"/_next/static/media/road-noise.32928ea0.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};